import { motion } from 'framer-motion';
import { useRef } from 'react';

function Test() {
    const fileInputRef = useRef(null);

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleFileUpload = (event) => {
        event.preventDefault();
        const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        // Gestisci i file caricati, ad esempio caricandoli sul server
        console.log(files);
    };

    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    return (
        <motion.div
            onDragOver={handleDragOver}
            onDrop={handleFileUpload}
            initial={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
            whileHover={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
            whileDrag={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
            drag
            dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
            style={{ width: 300, height: 200, border: '2px dashed black' }}
        >
            <div>Trascina le immagini qui o <button onClick={handleBrowseClick}>Sfoglia</button></div>
            <input type="file" accept="image/*" multiple ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileUpload} />
        </motion.div>
    );
}

export default Test;